<template>
    <v-card>
        <template v-if="isAdmin">
            <v-card-title>
                <v-btn
                    dark
                    color="primary"
                    class="mb-2"
                    :to="{ name: 'CadastrarBeneficio' }"
                >
                    <v-icon>add</v-icon> Cadastrar Benefício
                </v-btn>
                <v-divider
                    class="mx-3 hidden-md-and-down mt-0"
                    inset
                    vertical
                ></v-divider>
                <v-spacer></v-spacer>
            </v-card-title>
        </template>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
            <data-table :setup.sync="dataTable" @delete-item="deleteItem"></data-table>
        </v-card-text>
    </v-card>
</template>

<script>
import API from '@/api'
import DataTable from '@/components/DataTable'

export default {
    name: 'list-benefits',
    components: {
        DataTable
    },
    data () {
        return {
            isAdmin: false,
            dataTable: {
                loading: true,
                itemName: 'Benefício',
                headers: [
                    {
                        text: '',
                        value: 'logo',
                        img: {
                            tile: true,
                            width: 32,
                            height: 32,
                            else: {
                                key: 'name'
                            }
                        },
                        align: 'center',
                        sortable: false,
                        width: '5%'
                    },
                    { text: 'Empresa', value: 'name', sortable: false, width: '20%' },
                    { text: 'Beneficios', value: 'about', align: 'center', sortable: false, width: '75%' }
                ],
                items: [],
                totalItems: 0,
                editTo: 'EditarBeneficio',
                pagination: {
                    multiSort: true,
                    mustSort: false,
                    page: 1,
                    itemsPerPage: 500,
                    groupBy: [],
                    groupDesc: [],
                    sortBy: [],
                    sortDesc: [],
                    sortFormated: []
                },
                footerProps: {
                    itemsPerPageOptions: [500, 250, 100, 50, 25, 10]
                }
            }
        }
    },
    watch: {
        'dataTable.pagination.sortBy': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    if (this.dataTable.sortingTimeout !== undefined) clearTimeout(this.dataTable.sortingTimeout)
                    this.dataTable.sortingTimeout = setTimeout(() => {
                        this.loadData()
                    }, 1000)
                }
            },
            deep: true
        },
        'dataTable.pagination.page': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        },
        'dataTable.pagination.itemsPerPage': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        }
    },
    mounted () {
        this.adminOnly()
        this.loadData()
    },
    methods: {
        adminOnly: function () {
            if (this.$helpers.isAdmin()) {
                this.isAdmin = true
                this.dataTable.headers[2].width = '60%'
                this.dataTable.headers.push(
                    {
                        text: 'Ações',
                        value: 'actions',
                        align: 'center',
                        sortable: false,
                        edit: true,
                        delete: true,
                        width: '15%'
                    }
                )
            }
        },
        async loadData () {
            await this.$helpers.sleep(0)
            this.dataTable.loading = true
            let endpoint = API.EndPoints.getClubs
            let params = {
                limit: this.dataTable.pagination.itemsPerPage,
                skip: (this.dataTable.pagination.page - 1) * this.dataTable.pagination.itemsPerPage
            }
            new API(endpoint, params).request().then(response => {
                this.dataTable.items = response.body.results
                this.dataTable.totalItems = response.body.count
                this.dataTable.loading = false
            }, (e) => {
                this.$helpers.requestError(e)
            })
        },
        deleteFile (url) {
            return new Promise((resolve, reject) => {
                let endpoint = API.EndPoints.deleteFile
                let params = {
                    useMasterKey: true,
                    url: url
                }
                new API(endpoint, params).request()
                resolve()
            })
        },
        deleteItem: async function (item) {
            let endpoint = API.EndPoints.deleteClub
            endpoint.id = item.objectId
            let msg = ''
            if (item.logo) await this.deleteFile(item.logo.url)
            await new API(endpoint).request()
                .then(
                    (response) => { msg = 'Benefício removido com sucesso!' },
                    (error) => { msg = (error.status !== 0) ? error.data.error : '' }
                )
            if (msg !== '') alert(msg)
            this.loadData()
        }
    }
}
</script>
